const markersMap = {}; // id → { marker, el, votesEl, currentVotes }


// Get browser fingerprint (used to prevent duplicate votes)
async function getFingerprint() {
  const fp = await FingerprintJS.load();
  const result = await fp.get();
  return result.visitorId;
}


// Submit vote to backend
async function submitVote() {

  const restaurantId = document.getElementById("restaurantSelect").value;

  if (!restaurantId) {
    alert("Please select a restaurant");
    return;
  }

  const fingerprint = await getFingerprint();

  const res = await fetch("https://apis.tangosquared.com/ayrloom_munchies/php/vote.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      restaurantId,
      fingerprint
    })
  });

  const data = await res.json();

  if (data.success) {
    alert("Thanks for voting!");
    localStorage.setItem("ayrloom_voted_untilt2", Date.now() + 86400000);
  } else {
    alert(data.error || "Something went wrong");
  }
}


// Disable UI if already voted (frontend UX layer)
if (localStorage.getItem("ayrloom_voted_untilt2")) {
  document.addEventListener("DOMContentLoaded", () => {
    const votedUntil = localStorage.getItem("ayrloom_voted_untilt2");

    if (votedUntil && Date.now() < Number(votedUntil)) {
      document.getElementById("restaurantSelect").disabled = true;
    } else {
      localStorage.removeItem("ayrloom_voted_untilt2");
      document.getElementById("restaurantSelect").disabled = false;
    }
  });
}


// Restaurants
const locations = [
  {
    id: 1,
    name: "A.W. Wander",
    address: "145 E Seneca St, Manlius, NY 13104",
    url: "https://www.awwander.com",
    coords: [-75.9779592,43.0018716],
    opacity:0.4, region: "upstate",
    nominate: "Just Breathe Syracuse"
  },
  {
    id: 2,
    name: "Bar Bill North",
    address: "8326 Main St, Williamsville, NY 14221",
    url: "https://www.barbill.com/clarence",
    coords: [-78.6839364, 42.9652807],
    opacity:0.4, region: "upstate",
    nominate: "Honey Kenmore"
  },
  {
    id: 3,
    name: "Bedouin Tent",
    address: "405 Atlantic Ave, Brooklyn, NY 11217",
    url: "https://bedouintentny.com",
    coords: [-73.9844699, 40.6869576],
    opacity:0.4, region: "downstate",
    nominate: "Astro Management, Inc dba Yerba Buena"
  },
  {
    id: 4,
    name: "Ben's fresh",
    address: "33 E Main St, Port Jervis, NY 12771",
    url: "https://www.facebook.com/people/Bens-Fresh/100063774510982",
    coords: [-74.686287, 41.3761949],
    opacity:0.4, region: "upstate",
    nominate: "EasyJays Cannabis"
  },
  {
    id: 5,
    name: "Breakfast & Burger Club",
    address: "84 Main St, Nyack, NY 10960",
    url: "https://thebreakfastandburgerclub.com",
    coords: [-73.9186908, 41.0912543],
    opacity:0.4, region: "downstate",
    nominate: "Rockland Cannabis"
  },
  {
    id: 6,
    name: "Brooklyn Roots",
    address: "8620 3rd Ave, Brooklyn, NY 11209",
    url: "https://www.brooklynrootsitalian.com",
    coords: [-74.0315155, 40.6229337],
    opacity:0.4, region: "downstate",
    nominate: "Kaya Bliss - Bay Ridge"
  },
  {
    id: 7,
    name: "DA Taste",
    address: "864 Seneca St, Buffalo, NY 14210",
    url: "https://da-taste.square.site",
    coords: [-78.8451433, 42.8749159],
    opacity:0.4, region: "upstate",
    nominate: "Dream Daze Dispensary"
  },
  {
    id: 8,
    name: "Danny and Coops",
    address: "151 Avenue A, New York, NY 10009",
    url: "https://dannyandcoops.com",
    coords: [-73.9826788, 40.7276569],
    opacity:0.4, region: "downstate",
    nominate: "The Flowery East Village"
  },
  {
    id: 9,
    name: "District 37",
    address: "110 Sweeney St, North Tonawanda, NY 14120",
    url: "https://district37kitchenandtaphouse.com",
    coords: [-78.8788079, 43.0225168],
    opacity:0.4, region: "upstate",
    nominate: "Herbalwai"
  },
  {
    id: 43,
    name: "El Sabroso",
    address: "265 W 37th St, New York, NY 10018",
    url: "http://orderelsabroso.mobile-webview8.com",
    coords: [-73.9965242, 40.7540468],
    opacity:0.4, region: "upstate",
    nominate: "Indoor Treez 8th Avenue"
  },
  {
    id: 10,
    name: "Empire Bagel",
    address: "738 US-9 UNIT C6, Fishkill, NY 12524",
    url: "https://empire-bagels.com",
    coords: [-73.9013233, 41.5398103],
    opacity:0.4, region: "upstate",
    nominate: "Farmers Choice in Fishkill"
  },
  {
    id: 11,
    name: "Glizzy’s Grill",
    address: "7081 US-9, Plattsburgh, NY 12901",
    url: "https://empire-bagels.com",
    coords: [-73.4413913, 44.723323],
    opacity:0.4, region: "upstate",
    nominate: "The Herb cave"
  },
  {
    id: 12,
    name: "GMT Tavern",
    address: "142 Bleecker St, New York, NY 10012",
    url: "https://gmtnyc.com",
    coords: [-74.0017587, 40.7280459],
    opacity:0.4, region: "downstate",
    nominate: "Smacked Village"
  },
  {
    id: 13,
    name: "Hungry's",
    address: "10 State St, Pittsford, NY 14534",
    url: "https://www.hungrys-grill.com",
    coords: [-77.518569, 43.0674205],
    opacity:0.4, region: "upstate",
    nominate: "FingerLakes Cannabis Co"
  },
  {
    id: 14,
    name: "Joes pizza",
    address: "132 Broadway, Whitehall, NY 12887",
    url: "https://joespizzaandmore.com",
    coords: [-73.4077884, 43.5511914],
    opacity:0.4, region: "upstate",
    nominate: "Northern lights"
  },
  {
    id: 15,
    name: "La Nova",
    address: "371 W Ferry St, Buffalo, NY 14213",
    url: "https://www.lanova.com",
    coords: [-78.8906926, 42.915236],
    opacity:0.4, region: "upstate",
    nominate: "Secret Garden 716"
  },
  {
    id: 17,
    name: "Main St. Pizza",
    address: "206 E Main St, Batavia, NY 14020",
    url: "https://mainstreetpizzacompany.com",
    coords: [-78.9454062, 43.0924449],
    opacity:0.4, region: "upstate",
    nominate: "Mrs. Green's CANNAry"
  },
  {
    id: 18,
    name: "Mamas too",
    address: "2750 Broadway, New York, NY 10025",
    url: "https://www.mamastoo.com",
    coords: [-73.970165, 40.8008364],
    opacity:0.4, region: "downstate",
    nominate: "iDisepnseNYC"
  },
  {
    id: 20,
    name: "Mikes Underground Pizza",
    address: "0 Greene Ave, Amityville, NY 11701",
    url: "https://mikesundergroundpizza.com",
    coords: [-73.420128, 40.6783108],
    opacity:0.4, region: "downstate",
    nominate: "Happy Days Dispensary"
  },
  {
    id: 21,
    name: "Mr Taco",
    address: "619 North Ave, New Rochelle, NY 10801",
    url: "https://www.mistertaco.net",
    coords: [-73.7875546, 40.9229184],
    opacity:0.4, region: "downstate",
    nominate: "The Cannabis Reserve"
  },
  {
    id: 22,
    name: "Normanside",
    address: "150 Salisbury Rd, Delmar, NY 12054",
    url: "https://www.normanside.com",
    coords: [-73.8231667, 42.6392318],
    opacity:0.4, region: "upstate",
    nominate: "Leafy Peaks"
  },
  {
    id: 23,
    name: "Panda Harlem",
    address: "2331 12th Ave, New York, NY 10027",
    url: "https://www.pandaharlem.com",
    coords: [-73.958588, 40.8200015],
    opacity:0.4, region: "downstate",
    nominate: "Token Dispensary"
  },
  {
    id: 24,
    name: "Phatties",
    address: "880 Foote Ave, Jamestown, NY 14701",
    url: "https://www.facebook.com/share/18FpFJYyDm",
    coords: [-79.2263029, 42.0759827],
    opacity:0.4, region: "upstate",
    nominate: "Buzz WNY"
  },
  {
    id: 25,
    name: "Puertas",
    address: "8324 3rd Ave, Brooklyn, NY 11209",
    url: "https://www.puertasrestaurant.com",
    coords: [-74.0305285, 40.6251609],
    opacity:0.4, region: "downstate",
    nominate: "Kaya Bliss - Brooklyn Heights"
  },
  {
    id: 26,
    name: "Robke's Northport",
    address: "427 Fort Salonga Rd, Northport, NY 11768",
    url: "https://robkesofnorthport.com",
    coords: [-73.3389282, 40.892946],
    opacity:0.4, region: "downstate",
    nominate: "Long Island Cannabisclub"
  },
  {
    id: 27,
    name: "Ruggiero's",
    address: "123 Saratoga Rd, East Glenville, NY 12302",
    url: "https://robkesofnorthport.com",
    coords: [-73.936326, 42.859978],
    opacity:0.4, region: "upstate",
    nominate: "Madame Jane Cannabis Co"
  },
  {
    id: 29,
    name: "Ships pub",
    address: "360 Northern Blvd, Albany, NY 12204",
    url: "https://www.shipspub.com",
    coords: [-73.7515098, 42.6758665],
    opacity:0.4, region: "upstate",
    nominate: "Royale flower"
  },
  {
    id: 31,
    name: "Southern Junction",
    address: "360 Northern Blvd, Albany, NY 12204",
    url: "https://www.southernjunction716.com",
    coords: [-78.8898689, 42.9058625],
    opacity:0.4, region: "upstate",
    nominate: "Starbuds Buffalo"
  },
  {
    id: 32,
    name: "Southpaw Bistro",
    address: "7 South St, Glens Falls, NY 12801",
    url: "https://www.southpawbistro.com",
    coords: [-73.6493433, 43.3106999],
    opacity:0.4, region: "upstate",
    nominate: "Third Rock Cannabis in South Glens Falls, NY"
  },
  {
    id: 33,
    name: "Sultan",
    address: "791 Lexington Ave, New York, NY 10065",
    url: "https://sultannyc.com",
    coords: [-73.9694417, 40.7636921],
    opacity:0.4, region: "downstate",
    nominate: "MaryJane Cannabis Co"
  },
  {
    id: 42,
    name: "Taco Island",
    address: "2320 N Ocean Ave, Farmingville, NY 11738",
    url: "https://thetacoisland.com",
    coords: [-73.0604213, 40.8323731],
    opacity:0.4, region: "downstate",
    nominate: "Joint Venture"
  },
  {
    id: 36,
    name: "Taglio Pizza (Mineola)",
    address: "85 Mineola Blvd, Mineola, NY 11501",
    url: "https://www.syracusegyro.com",
    coords: [-73.6430309, 40.7410411],
    opacity:0.4, region: "downstate",
    nominate: "Sage Seeds"
  },
  {
    id: 37,
    name: "Thai Diner",
    address: "186 Mott St, New York, NY 10012",
    url: "https://www.thaidiner.com",
    coords: [-73.9982249, 40.7207183],
    opacity:0.4, region: "downstate",
    nominate: "Alta Dispensary"
  },
  {
    id: 38,
    name: "The Bearded Bear BBQ",
    address: "177 Cayuga St, Union Springs, NY 13160",
    url: "https://thebeardedbearbbq.com",
    coords: [-76.6947164, 42.8439421],
    opacity:0.4, region: "upstate",
    nominate: "Just Breathe Finger Lakes"
  },
  {
    id: 39,
    name: "The Ruck",
    address: "104 3rd St, Troy, NY 12180",
    url: "https://getrucked.com",
    coords: [-73.695611, 42.7284137],
    opacity:0.4, region: "upstate",
    nominate: "Royale flower"
  },
  {
    id: 40,
    name: "Tully's",
    address: "1225 Jefferson Rd, Rochester, NY 14623",
    url: "https://www.tullysgoodtimes.com",
    coords: [-77.6030309, 43.0864206],
    opacity:0.4, region: "upstate",
    nominate: "MJ Dispensary"
  },
  {
    id: 41,
    name: "Ungaro's",
    address: "1298 Forest Ave, Staten Island, NY 10302",
    url: "https://www.ungarocoalfiredpizzacafe.com",
    coords: [-74.1357694, 40.6261883],
    opacity:0.4, region: "downstate",
    nominate: "Nug"
  },
  {
    id: 35,
    name: "Taco Boys Mexican Grill",
    address: "23 NY-59, Nyack, NY 10960",
    url: "https://tacoboysny.com",
    coords: [-73.9344313, 41.0928981],
    opacity:0.4, region: "downstate",
    nominate: "Treehouse Cannabis"
  },
  {
    id: 40,
    name: "Tully's",
    address: "1225 Jefferson Rd, Rochester, NY 14623",
    url: "https://www.tullysgoodtimes.com",
    coords: [-77.6030309, 43.0864206],
    opacity:0.4, region: "upstate",
    nominate: "MJ Dispensary"
  },
  {
    id: 2,
    name: "Bar Bill North",
    address: "8326 Main St, Williamsville, NY 14221",
    url: "https://www.barbill.com/clarence",
    coords: [-78.6839364, 42.9652807],
    opacity:0.4, region: "upstate",
    nominate: "Honey Kenmore"
  },
  {
    id: 23,
    name: "Panda Harlem",
    address: "2331 12th Ave, New York, NY 10027",
    url: "https://www.pandaharlem.com",
    coords: [-73.958588, 40.8200015],
    opacity:0.4, region: "downstate",
    nominate: "Token Dispensary"
  },
  {
    id: 35,
    name: "Taco Boys Mexican Grill",
    address: "23 NY-59, Nyack, NY 10960",
    url: "https://tacoboysny.com",
    coords: [-73.9344313, 41.0928981],
    opacity:0.4, region: "downstate",
    nominate: "Treehouse Cannabis"
  },
  {
    id: 34,
    name: "Syracuse Halal Gyro",
    address: "477 Westcott St, Syracuse, NY 13210",
    url: "https://www.syracusegyro.com",
    coords: [-76.1216593, 43.0418403],
    opacity:0.4, region: "upstate",
    nominate: "VedaLeaf"
  },
  {
    id: 16,
    name: "Macys Place Pizzeria",
    address: "8885 Main St, Buffalo, NY 14221",
    url: "https://www.macysplacepizzeria.com",
    coords: [-78.660797, 42.966603],
    opacity:0.4, region: "upstate",
    nominate: "Flynnstoned Buffalo"
  },
  {
    id: 19,
    name: "Mashed Burgers",
    address: "66 Mamaroneck Ave, White Plains, NY 10601",
    url: "https://www.instagram.com/mashedburgers",
    coords: [-73.7662367, 41.0309187],
    opacity:1, region: "downstate",
    nominate: "Starlife Dispensary"
  },
  {
    id: 28,
    name: "Scarr’s Pizza",
    address: "35 Orchard St, New York, NY 10002",
    url: "https://www.scarrspizza.com",
    coords: [-73.9941864, 40.7157278],
    opacity:0.4, region: "downstate",
    nominate: "CONBUD"
  },
];


// Get votes
async function fetchVotes() {
  const res = await fetch("https://apis.tangosquared.com/ayrloom_munchies/php/results.php");
  const data = await res.json();

  const votesMap = {};
  data.forEach(item => {
    votesMap[item.id] = item.votes;
  });

  return votesMap;
}


// MapBox init
mapboxgl.accessToken = 'pk.eyJ1IjoiZmF0aGVybWljaGFlbCIsImEiOiJjbW14YWU4bmYyN3M0MnFzOG1vbWxtd3lvIn0.tOPq7ToDiboStQeV_Y0gEA';

const map = new mapboxgl.Map({
  container: 'mapgl',
  style: 'mapbox://styles/mapbox/streets-v11',
  center: [-74.5, 42.7],
  zoom: 6
});


// Marker rendering
async function renderMarkers() {
  const votesMap = await fetchVotes();

  locations.forEach(loc => {

    const votes = votesMap[loc.id] || 0;

    const el = document.createElement('div');
    el.className = 'marker';
    el.style.opacity = loc.opacity ?? 1;

    const isGray = loc.opacity === 0.4;

    let imgSrc;

    if (loc.region === 'downstate') {
      imgSrc = isGray ? window.MARKERS.downGray : window.MARKERS.down;
    } else {
      imgSrc = isGray ? window.MARKERS.upGray : window.MARKERS.up;
    }

    el.innerHTML = `
      <div class="marker-wrap">
        <img src="${imgSrc}" />
        <span class="votes">${votes}</span>
      </div>
    `;

    const votesEl = el.querySelector('.votes');

    const popup = new mapboxgl.Popup({ offset: 25 }).setHTML(`
      <strong>${loc.name}</strong><br>
      ${loc.address}<br>
      Nominated by: ${loc.nominate}<br>
      Votes: <span class="popup-votes">${votes}</span><br>
      <a href="${loc.url}" target="_blank">Visit website</a>
    `);

    const marker = new mapboxgl.Marker(el)
      .setLngLat(loc.coords)
      .setPopup(popup)
      .addTo(map);

    // save marker
    markersMap[loc.id] = {
      marker,
      el,
      votesEl,
      currentVotes: votes,
      region: loc.region
    };
  });
}



/* update votes every 10 seconds */
async function updateVotes() {
  const votesMap = await fetchVotes();

  Object.keys(markersMap).forEach(id => {
    const markerData = markersMap[id];
    const newVotes = votesMap[id] || 0;

    if (newVotes !== markerData.currentVotes) {

      // update number
      markerData.votesEl.textContent = newVotes;

      // animation
      markerData.votesEl.classList.add('vote-bump');

      setTimeout(() => {
        markerData.votesEl.classList.remove('vote-bump');
        markerData.votesEl.style.color = "white";
      }, 500);

      markerData.currentVotes = newVotes;
    }
  });
}

// every 10 seconds
map.on('load', () => {
  renderMarkers();
  setInterval(updateVotes, 10000);
});